
<div class="qq-summary__block__quote_result" *ngIf="quote && !quote?.result?.error">
  <label class="qq-summary__block__quote__amount">
    {{result?.premium | pounds}}<small>{{result?.premium | appcents}}</small>
    <span class="pm">/month</span>
  </label>   
  <label class="qq-summary__block__quote__valid">
    Quote valid until: {{result.validUntil | date:'dd/MM/yyyy'}}
  </label>
</div>

<div class="qq-summary__result" *ngIf="quote?.result?.error">
  <div [innerHtml]="quote.result.error"></div>
</div>

<div class="qq-summary__block__quote__title" *ngIf="answersObject">Summary</div>
<app-questionnaire-summary title="{{title}}" *ngIf="answersObject">
  <app-summary-row label="Name">
    {{answersObject["FirstPolicyHolderFirstName"]}} {{answersObject["FirstPolicyHolderSurName"]}}
  </app-summary-row>
  <app-summary-row label="Date of Birth">
    {{answersObject["FirstPolicyHolderDOB"] | date:'dd/MM/yyy'}}
  </app-summary-row>
  <app-summary-row label="Smoker Status">
    {{answersObject["FirstPolicyHolderSmoker"] === 'YES' ? 'Smoker': 'Non Smoker'}}
  </app-summary-row>
  <app-summary-row label="Type of policy">
    {{answersObject["TypeOfPolicy_1"] === 'SINGLE' ? 'Just me': 'For you and your partner'}}
  </app-summary-row>
  <app-summary-row label="Cover Type">
    {{answersObject["CoverBasis_1"] === 'LEVEL' ? 'Level term Family cover': 'Decreasing term Mortgage cover'}}
  </app-summary-row>
  <app-summary-row label="Life Cover of">
    {{answersObject["ProtectionLevel_1"] | pounds}}
  </app-summary-row>

  <ng-container *ngIf="answersObject['TypeOfPolicy_1'] === 'DUAL'">
    <app-summary-row label="Second Policy Holder">
      {{answersObject['SecondPolicyHolderFirstName']}} {{answersObject['SecondPolicyHolderSurName']}}
    </app-summary-row>
    <app-summary-row label="Second Policy Holder Date of Birth">
      {{answersObject['SecondPolicyHolderDOB']}}
    </app-summary-row>
    <app-summary-row label="Second Policy Holder Smoker Status">
      {{answersObject["SecondPolicyHolderSmoker"] === 'YES' ? 'Smoker': 'Non Smoker'}}
    </app-summary-row>
  </ng-container>
  
  <app-summary-row label="Term">
    {{answersObject["PolicyTerm_1"]}} years
  </app-summary-row>
  <app-summary-row label="Critical Illness Cover" *ngIf="!answersObject['PolicyType_2']">
    {{answersObject["PolicyType_1"] === 'TERM-CI' ? 'Included': 'Excluded'}}
  </app-summary-row>
  <app-summary-row label="Address" *ngIf="page === 'summary-2'">
    <div *ngFor="let line of addressLines">{{line}}</div>
  </app-summary-row>
</app-questionnaire-summary>
<div *ngIf="answersObject['PolicyType_2']">
  <app-questionnaire-summary title="Life with Multi-Claim Critical Illness cover">
    <app-summary-row label="Type of policy">
      {{answersObject["TypeOfPolicy_2"] === 'SINGLE' ? 'Just me': 'For you and your partner'}}
    </app-summary-row>
    <app-summary-row label="Cover Type">
      {{answersObject["CoverBasis_2"] === 'LEVEL' ? 'Level term Family cover': 'Decreasing term Mortgage cover'}}
    </app-summary-row>
    <app-summary-row label="Life with CI Cover of">
      {{answersObject["ProtectionLevel_2"] | pounds}}
    </app-summary-row>
    <app-summary-row label="Term">
      {{answersObject["PolicyTerm_2"]}} years
    </app-summary-row>
  </app-questionnaire-summary>
</div>